import * as yup from 'yup';
import { RequestAccessFormData } from './constants';

export const requestAccessSchema: yup.ObjectSchema<RequestAccessFormData> =
  yup.object({
    justification: yup
      .string()
      .trim()
      .required('*Required')
      .max(255, 'Must be 255 characters or fewer'),
    duration: yup
      .mixed<RequestAccessFormData['duration']>()
      .oneOf(['1-hour', '1-day', '1-week', 'permanent'])
      .required('Duration is required'),
  });
